import { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  TextField,
  MenuItem,
} from "@mui/material";
import {
  BlacklistScope,
  BrokerCheck,
} from "../../../api/brokerBlacklistService";
import BrokerBlacklistWarning from "./BrokerBlacklistWarning";

export default function CheckBrokerButton() {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState<BlacklistScope | "">("");
  const [type, setType] = useState<"mcNumber" | "dotNumber">("mcNumber");
  const [value, setValue] = useState("");
  const [checked, setChecked] = useState<BrokerCheck>();
  const [attempt, setAttempt] = useState(0);
  const reset = () => setChecked(undefined);
  return (
    <>
      <Button
        variant="outlined"
        onClick={() => {
          setOpen(true);
          reset();
        }}
      >
        Check broker
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Check broker</DialogTitle>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            setAttempt((previous) => previous + 1);
            setChecked({ list: list || undefined, [type]: value.trim() });
          }}
        >
          <DialogContent dividers>
            <Stack spacing={2}>
              <TextField
                select
                label="Blacklist"
                value={list}
                onChange={(e) => {
                  setList(e.target.value as BlacklistScope | "");
                  reset();
                }}
              >
                <MenuItem value="">C1 and Fox</MenuItem>
                <MenuItem value="C1">C1</MenuItem>
                <MenuItem value="Fox">Fox</MenuItem>
              </TextField>
              <TextField
                select
                label="Identifier type"
                value={type}
                onChange={(e) => {
                  setType(e.target.value as typeof type);
                  reset();
                }}
              >
                <MenuItem value="mcNumber">MC number</MenuItem>
                <MenuItem value="dotNumber">DOT number</MenuItem>
              </TextField>
              <TextField
                autoFocus
                required
                label={type === "mcNumber" ? "MC number" : "DOT number"}
                value={value}
                onChange={(e) => {
                  setValue(e.target.value);
                  reset();
                }}
                inputProps={{ maxLength: 32 }}
              />
              {checked && (
                <BrokerBlacklistWarning key={attempt} input={checked} />
              )}
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>Close</Button>
            <Button type="submit" variant="contained" disabled={!value.trim()}>
              Check
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
